import img1 from "./photos/1_result.webp";
import img2 from "./photos/2_result.webp";
import img3 from "./photos/3_result.webp";
import img4 from "./photos/4_result.webp";
import img5 from "./photos/5_result.webp";
import img6 from "./photos/6_result.webp";
import img7 from "./photos/7_result.webp";
import img8 from "./photos/8_result.webp";
import img9 from "./photos/9_result.webp";
import img10 from "./photos/10_result.webp";
import img11 from "./photos/11_result.webp";
import img12 from "./photos/12_result.webp";
import img13 from "./photos/13_result.webp";
import img14 from "./photos/14_result.webp";
import img15 from "./photos/15_result.webp";
import img16 from "./photos/16_result.webp";
import img17 from "./photos/17_result.webp";
import img18 from "./photos/18_result.webp";
import img19 from "./photos/19_result.webp";
import img20 from "./photos/20_result.webp";
import img21 from "./photos/21_result.webp";
import img22 from "./photos/22_result.webp";
import img23 from "./photos/23_result.webp";
import img24 from "./photos/24_result.webp";
import img26 from "./photos/26_result.webp";
import img27 from "./photos/27_result.webp";
import img28 from "./photos/28_result.webp";
import img29 from "./photos/29_result.webp";
import img30 from "./photos/30_result.webp";
import img31 from "./photos/31_result.webp";
import img32 from "./photos/32_result.webp";
import img33 from "./photos/33_result.webp";
import img34 from "./photos/34_result.webp";

export const galleryImages = [
    { id: 1, image: img1 },
    { id: 2, image: img2 },
    { id: 3, image: img3 },
    { id: 4, image: img4 },
    { id: 5, image: img5 },
    { id: 6, image: img6 },
    { id: 7, image: img7 },
    { id: 8, image: img8 },
    { id: 9, image: img9 },
    { id: 10, image: img10 },
    { id: 11, image: img11 },
    { id: 12, image: img12 },
    { id: 13, image: img13 },
    { id: 14, image: img14 },
    { id: 15, image: img15 },
    { id: 16, image: img16 },
    { id: 17, image: img17 },
    { id: 18, image: img18 },
    { id: 19, image: img19 },
    { id: 20, image: img20 },
    { id: 21, image: img21 },
    { id: 22, image: img22 },
    { id: 23, image: img23 },
    { id: 24, image: img24 },
    { id: 26, image: img26 },
    { id: 27, image: img27 },
    { id: 28, image: img28 },
    { id: 29, image: img29 },
    { id: 30, image: img30 },
    { id: 31, image: img31 },
    { id: 32, image: img32 },
    { id: 33, image: img33 },
    { id: 34, image: img34 },

];